import React from "react";
import { useNavigate } from "react-router-dom";
import { AppState, Auth0Provider } from "@auth0/auth0-react";

/**
 * Props for Auth0ProviderWithHistory component
 */
interface Auth0ProviderWithHistoryProps {
  /** Child components to render */
  children: React.ReactNode;
}

/**
 * Wraps Auth0Provider with navigation and state management
 * Handles authentication redirects and state validation
 */
const Auth0ProviderWithHistory: React.FC<Auth0ProviderWithHistoryProps> = ({
  children,
}) => {
  const navigate = useNavigate();

  /**
   * Handles redirect callback after authentication
   * Navigates back to the page the user was trying to open
   */
  const onRedirectCallback = (appState?: AppState) => {
    const redirectTo = appState?.returnTo || "/your-collections";
    navigate(redirectTo, { replace: true });
  };

  return (
    <Auth0Provider
      domain={import.meta.env.VITE_AUTH0_DOMAIN}
      clientId={import.meta.env.VITE_AUTH0_CLIENT_ID}
      authorizationParams={{
        redirect_uri: import.meta.env.VITE_AUTH0_REDIRECT_URI,
        audience: import.meta.env.VITE_AUTH0_AUDIENCE,
        scope: "openid profile email",
      }}
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
};

export default Auth0ProviderWithHistory;
